const registerInitialValues = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    dni: '',
    companyName: '',
    role: '',
    base: ''
}

export default registerInitialValues
